/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Demo_Note_TitleInputs */

const en_draft_demo_note_title = /** @type {(inputs: Draft_Demo_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const ar_draft_demo_note_title = /** @type {(inputs: Draft_Demo_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاحظة`)
};

const bn_draft_demo_note_title = /** @type {(inputs: Draft_Demo_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নোট`)
};

const de_draft_demo_note_title = /** @type {(inputs: Draft_Demo_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis`)
};

const es_draft_demo_note_title = /** @type {(inputs: Draft_Demo_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota`)
};

const fr_draft_demo_note_title = /** @type {(inputs: Draft_Demo_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remarque`)
};

const pt_draft_demo_note_title = /** @type {(inputs: Draft_Demo_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota`)
};

const zh_draft_demo_note_title = /** @type {(inputs: Draft_Demo_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注意`)
};

const tr_draft_demo_note_title = /** @type {(inputs: Draft_Demo_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not`)
};

const ru_draft_demo_note_title = /** @type {(inputs: Draft_Demo_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечание`)
};

const pl_draft_demo_note_title = /** @type {(inputs: Draft_Demo_Note_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uwaga`)
};

/**
* | output |
* | --- |
* | "Note" |
*
* @param {Draft_Demo_Note_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const draft_demo_note_title = /** @type {((inputs?: Draft_Demo_Note_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Demo_Note_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_draft_demo_note_title(inputs)
	if (locale === "bn") return bn_draft_demo_note_title(inputs)
	if (locale === "de") return de_draft_demo_note_title(inputs)
	if (locale === "es") return es_draft_demo_note_title(inputs)
	if (locale === "fr") return fr_draft_demo_note_title(inputs)
	if (locale === "pt") return pt_draft_demo_note_title(inputs)
	if (locale === "zh") return zh_draft_demo_note_title(inputs)
	if (locale === "tr") return tr_draft_demo_note_title(inputs)
	if (locale === "ru") return ru_draft_demo_note_title(inputs)
	if (locale === "pl") return pl_draft_demo_note_title(inputs)
	return en_draft_demo_note_title(inputs)
});